import addDays from '../add-days';
import isSameDay from '../is-same-day';
import toDate from '../to-date';

export const isTomorrow = (date: Date | number): boolean => {
  const formattedDate = toDate(date);

  return isSameDay(formattedDate, addDays(Date.now(), 1));
};

export default isTomorrow;
